<template>
  <div
    v-if="checkRoleSuccess === true"
  >
    <navbar class="navbar" />
    <v-row>
      <v-col>
        <v-card outlined>
          <v-card-text>

            <v-row><v-col><h3>สิทธิ์</h3></v-col></v-row>
            <v-row><v-divider></v-divider></v-row>

            <v-row>
              <v-col xs="12" sm="12" md="6" lg="6" cols="12">
                <v-text-field
                  dense
                  autocomplete="off"
                  outlined
                  hide-details="auto"
                  label="บัญชีผู้ใช้"
                  v-model="valueInput.username"
                  :rules="rule.username"
                  ref="username"
                  maxLength=20
                  @keypress="handleNotSpaceBar($event)"
                ></v-text-field>
              </v-col>

              <v-col xs="12" sm="12" md="6" lg="6" cols="12">
                <v-text-field
                  dense
                  autocomplete="off"
                  outlined
                  hide-details="auto"
                  label="รหัสผ่าน"
                  v-model="valueInput.password"
                  :rules="rule.password"
                  ref="password"
                  maxLength=20
                  @keypress="handleNotSpaceBar($event)"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col xs="12" sm="12" md="6" lg="6" cols="12">
                <v-text-field
                  dense
                  autocomplete="off"
                  outlined
                  hide-details="auto"
                  label="ชื่อ"
                  v-model="valueInput.firstName"
                  :rules="rule.firstName"
                  ref="firstName"
                ></v-text-field>
              </v-col>

              <v-col xs="12" sm="12" md="6" lg="6" cols="12">
                <v-text-field
                  autocomplete="off"
                  dense
                  outlined
                  hide-details="auto"
                  label="นามสกุล"
                  v-model="valueInput.lastName"
                  :rules="rule.lastName"
                  ref="lastName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="$route.name === 'UserCreate' && userRank === 10 && userRole !== 'superprovider'">
              <v-col xs="12" sm="12" md="12" lg="6" cols="12">
                <v-select
                  :items="providerData"
                  label="ผู้ให้บริการ"
                  item-value="_id"
                  item-text="name"
                  return-object
                  outlined
                  hide-details="auto"
                  dense
                  autocomplete="off"
                  v-model="valueInput.provider"
                  ref="provider"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="$route.name === 'UserEdit' && userRank < 10 || $route.name === 'UserCreate'">
              <v-col>
                <v-radio-group v-model="valueInput.role" column hide-details class="mt-1">
                  <p>สิทธิ์</p>
                  <v-radio  v-if="userRank > 5" label="Super Provider" value="superprovider"></v-radio>
                  <v-radio  v-if="userRank > 4" label="Admin Provider" value="admin"></v-radio>
                  <v-radio   v-if="userRank > 1" label="User Provider" value="user"></v-radio>
                </v-radio-group>

              </v-col>
            </v-row>

            <v-row>
              <v-divider></v-divider>
            </v-row>
            <v-row  class="d-flex flex-row-reverse">
              <v-col sm="12" md="12" lg="3" cols="12">
                <v-btn
                  color="success"
                  depressed
                  width="100%"
                  class="pa-5"
                  v-on:click="handleInsertData()"
                >
                  <v-icon>mdi-content-save</v-icon>
                  บันทึกรายการ
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import script from '@/views/pages/user/form/form.script';

export default script;
</script>
